import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_SERVER_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});



export const WEBApi = {

  getBlogs: async (page: number) => {
    const response = await api.get(`/api/blogs?page=${page}`);
    return response.data;
  },

  getBlogBySlug: async (slug: string) => {
    const response = await api.get(`/api/blogs/${slug}/view`);
    return response.data;
  },


  getRecognitions: async (page: number) => {
    const response = await api.get(`/api/recognitions?page=${page}&limit=10`);
    return response.data;
  },

  createNewContact: async ({
    firstName,
    lastName,
    email,
    phone,
    propertyType,
    message,
    recaptchaToken
  }: {
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    propertyType: string;
    message: string;
    recaptchaToken:string;
  }) => {
    const response = await api.post('/api/inbound', {
      firstName,
      lastName,
      email,
      phone,
      propertyType,
      message,
      recaptchaToken
    });
    return response;
  },
  getPublishedRecognitions: async (page = 1, limit = 8) => {
    const response = await api.get(`/api/recognitions?page=${page}&limit=${limit}`);
    return response.data;
  }
  

};
